import React, { useState } from "react";
import styled from "styled-components";
// import common components
import FooterLinkSection from "../common-components/FooterLinkSection";
import Typography, { TYPE_ELEMENTS } from "../common-components/Typography";
import CTAButton from "../common-components/CTAButton";
import BrochureModal from "../common-components/BrochureModal";
// import assets
import footerLogo from "../assets/sr-logo-footer.webp";
import makeInIndiaLogo from "../assets/make-in-india-logo.svg";
import facebookIcon from "../assets/icons/socials/facebook.svg";
import instaIcon from "../assets/icons/socials/insta.svg";
import linkedinIcon from "../assets/icons/socials/linkedin.svg";
import twitterIcon from "../assets/icons/socials/twitter.svg";
// import constants
import CONSTANTS from "../utils/constants/constants";

const {
  PAGES,
  APPLICATIONS,
  TECHNOLOGY,
  BROCHURES,
  CONTACT,
  FOLLOW_US,
  LOCATION,
  QUERIES,
} = CONSTANTS.FOOTER;

const { SOCIAL_LINKS } = CONSTANTS;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  background: linear-gradient(to top, #232c60 0%, #000000 60%);
  color: #fff;
  padding: 280px 112px 24px 112px;

  @media (max-width: 1024px) {
    padding: 96px 112px;
  }

  @media (max-width: 640px) {
    padding: 48px 32px;
  }
`;

export const FooterMain = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 192px;
  width: 100%;
  // max-width: 1100px;

  // @media (max-width: 1024px) {
  //   max-width: 600px;
  //   flex-direction: column;
  //   align-items: flex-start;
  //   gap: 64px;
  // }

  @media (max-width: 640px) {
    gap: 40px;
  }
`;

export const FooterColumn = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  flex-direction: column;
  justify-content: space-between;
  gap: 96px;
  width: fit-content;

  @media (max-width: 1024px) {
    display: flex;
    width: 100%;
    flex-direction: row;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;

  img {
    width: 180px;
    // margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    color: #aaa;
    margin: 0px;
  }

  @media (max-width: 480px) and (hover: none) and (pointer: coarse),
    (max-height: 480px) and (hover: none) and (pointer: coarse),
    (max-width: 480px) and (pointer: coarse),
    (max-height: 480px) and (pointer: coarse) {
    display: none;
  }
`;

export const FooterSeparator = styled.div`
  border-top: 1px solid #fff;
  margin: 20px 0;
  width: 100%;
  max-width: 1100px;
`;

export const FooterBottomBanner = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // max-width: 1100px;

  @media (max-width: 1024px) {
    max-width: 600px;
  }
`;

export const Copyright = styled.p`
  font-size: 12px;
  color: #aaa;
  text-align: left;
`;

const LogoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const RightSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 192px;
  row-gap: 40px;
  width: 100%;

  @media (max-width: 1600px) {
    column-gap: 90px;
  }

  @media (max-width: 1400px) {
    column-gap: 60px;
  }

  @media (max-width: 1280px) {
    column-gap: 30px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    column-gap: 200px;
    row-gap: 24px;
  }

  @media (max-width: 768px) {
    column-gap: 72px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

function Footer() {
  if (window.innerWidth <= 480) {
    return (
      <FooterContainer className="footer-container-max-width-480">
        <FooterMain className="footer-main">
          <RightSection>
            <FooterLogo onClick={() => (window.location.href = "/")}>
              <img src={footerLogo} alt="Sisir Radar" />
              <p>Sisir Radar Private Limited</p>
            </FooterLogo>
            <FollowUsBlock
              className="follow-us-block"
              noHeader={true}
              justifyContent="flex-start"
            />
            <FooterLinkSection header={PAGES.HEADER} items={PAGES.LINKS} />
            <FooterLinkSection
              header={APPLICATIONS.HEADER}
              items={APPLICATIONS.LINKS}
            />
            <FooterLinkSection
              header={TECHNOLOGY.HEADER}
              items={TECHNOLOGY.LINKS}
            />
            <FooterLinkSection
              header={BROCHURES.HEADER}
              items={BROCHURES.TYPES}
              hasLink={true}
            />
            <FooterLinkSection
              header={LOCATION.HEADER}
              items={LOCATION.CONTENT}
              isTextOnly
            />
            <FooterLinkSection
              header={QUERIES.HEADER}
              items={QUERIES.CONTENT}
              isTextOnly
            />
          </RightSection>
        </FooterMain>
        <FooterBottomBanner>
          <Copyright>{CONSTANTS.COPYRIGHT}</Copyright>
          <img src={makeInIndiaLogo} alt="Made in India" />
        </FooterBottomBanner>
      </FooterContainer>
    );
  }

  if (window.innerWidth <= 1024) {
    return (
      <FooterContainer className="footer-container-max-width-1024">
        <LogoBlock>
          <FooterLogo onClick={() => (window.location.href = "/")}>
            <img src={footerLogo} alt="Sisir Radar" />
            <p>Sisir Radar Private Limited</p>
          </FooterLogo>
          <FollowUsBlock
            className="follow-us-block"
            noHeader={true}
            justifyContent="flex-start"
          />
        </LogoBlock>
        <FooterMain className="footer-main">
          <RightSection>
            <>
              <FooterLinkSection header={PAGES.HEADER} items={PAGES.LINKS} />
              <FooterLinkSection
                header={APPLICATIONS.HEADER}
                items={APPLICATIONS.LINKS}
              />
            </>
            <>
              <FooterLinkSection
                header={TECHNOLOGY.HEADER}
                items={TECHNOLOGY.LINKS}
              />
              <FooterLinkSection
                header={BROCHURES.HEADER}
                items={BROCHURES.TYPES}
                hasLink={true}
              />
            </>
            <>
              <FooterLinkSection
                header={LOCATION.HEADER}
                items={LOCATION.CONTENT}
                isTextOnly
              />
              <FooterLinkSection
                header={QUERIES.HEADER}
                items={QUERIES.CONTENT}
                isTextOnly
              />
            </>
          </RightSection>
        </FooterMain>
        <FooterBottomBanner>
          <Copyright>{CONSTANTS.COPYRIGHT}</Copyright>
          <img src={makeInIndiaLogo} alt="Made in India" />
        </FooterBottomBanner>
      </FooterContainer>
    );
  }

  return (
    <FooterContainer className="footer-container">
      <FooterMain className="footer-main">
        <RightSection>
          <FooterLogo onClick={() => (window.location.href = "/")}>
            <img src={footerLogo} alt="Sisir Radar" />
            <p>Sisir Radar Private Limited</p>
          </FooterLogo>
          <FooterLinkSection header={PAGES.HEADER} items={PAGES.LINKS} />
          <FooterLinkSection
            header={TECHNOLOGY.HEADER}
            items={TECHNOLOGY.LINKS}
          />
          <FooterLinkSection
            header={LOCATION.HEADER}
            items={LOCATION.CONTENT}
            isTextOnly
          />
          <FollowUsBlock
            className="follow-us-block"
            noHeader={true}
            justifyContent="flex-start"
          />
          <FooterLinkSection
            header={APPLICATIONS.HEADER}
            items={APPLICATIONS.LINKS}
          />
          <FooterLinkSection
            header={BROCHURES.HEADER}
            items={BROCHURES.TYPES}
            hasLink={true}
          />
          <FooterLinkSection
            header={QUERIES.HEADER}
            items={QUERIES.CONTENT}
            isTextOnly
          />
        </RightSection>
      </FooterMain>
      <FooterBottomBanner>
        <Copyright>{CONSTANTS.COPYRIGHT}</Copyright>
        <img src={makeInIndiaLogo} alt="Made in India" />
      </FooterBottomBanner>
    </FooterContainer>
  );
}

const FollowUsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  max-width: 200px;

  @media (max-width: 640px) {
    max-width: 100%;
    gap: 4px;
  }
`;

const SocialIconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const SocialIcon = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    transition: transform 0.3s ease-in-out;
  }

  @media (max-width: 640px) {
    width: 24px;
    height: 24px;
  }
`;

function FollowUsBlock({ noHeader = false, justifyContent = "flex-start" }) {
  return (
    <FollowUsSection style={{ justifyContent: justifyContent }}>
      {!noHeader && (
        <Typography typeElement={TYPE_ELEMENTS.SUBTITLE_2}>
          {FOLLOW_US.HEADER}
        </Typography>
      )}
      <SocialIconsWrapper>
        <SocialIcon
          src={linkedinIcon}
          alt="LinkedIn"
          onClick={() => window.open(SOCIAL_LINKS.LINKEDIN, "_blank")}
        />
        <SocialIcon
          src={twitterIcon}
          alt="Twitter"
          onClick={() => window.open(SOCIAL_LINKS.TWITTER, "_blank")}
        />
        <SocialIcon
          src={facebookIcon}
          alt="Facebook"
          onClick={() => window.open(SOCIAL_LINKS.FACEBOOK, "_blank")}
        />
        <SocialIcon
          src={instaIcon}
          alt="Instagram"
          onClick={() => window.open(SOCIAL_LINKS.INSTAGRAM, "_blank")}
        />
      </SocialIconsWrapper>
      <CTAButton
        onClick={() => (window.location.href = "/contact")}
        text={CONSTANTS.BUTTONS.CONTACT}
      />
    </FollowUsSection>
  );
}

export default Footer;
